import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/movies", label: "电影分类", end: false },
  { to: "/cinemas", label: "影院排片", end: false },
  { to: "/news", label: "影讯专题", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const overlay = isHome && !scrolled;

  return (
    <header
      className={`${
        isHome ? "fixed" : "sticky"
      } top-0 z-50 w-full transition-colors duration-300 ${
        overlay
          ? "bg-transparent"
          : "border-b border-background-200 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-tight ${
              overlay ? "text-background-50" : "text-foreground-950"
            }`}
          >
            九七电影院
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  overlay
                    ? isActive
                      ? "text-background-50 underline decoration-accent-400 decoration-2 underline-offset-8"
                      : "text-background-100/80 hover:text-background-50"
                    : isActive
                      ? "text-accent-600"
                      : "text-foreground-700 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-64 lg:block">
          <SearchBox />
        </div>

        <Link
          to="/cinemas"
          className="ml-auto hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:ml-3 lg:block"
        >
          快速购票
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className={`ml-auto flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            overlay ? "text-background-50" : "text-foreground-900"
          }`}
          aria-label="菜单"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="mb-3">
            <SearchBox onNavigate={() => setMenuOpen(false)} />
          </div>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}